export default __webpack_public_path__ + "static/media/experience.47fd458e.svg";